import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const SettingsTabFailedLoading = () => {
    return (
        <div className="flex h-125 items-center justify-center">
            <div className="flex flex-col items-center">
                <TypographyH3 className="text-2xl font-semibold tracking-tight">
                    {UIStrings.OopsSomethingWentWrong}
                </TypographyH3>
                <TypographyP className="text-base">{UIStrings.PleaseRefresh}</TypographyP>
            </div>
        </div>
    );
};

export default SettingsTabFailedLoading;
